import React from "react";

const Select = ({
  label,
  selectClassName,
  name,
  value,
  handleChange,
  inputFocus,
  datagroup,
  options,
  isBold,
}) => {
  return (
    <div className="position-relative">
      <label
        htmlFor={name}
        className={`${isBold ? "form-label fw-bold" : "form-label"}`}
      >
        {label}&nbsp;<span className="text-danger">*</span>
      </label>
      <select
        className={"form-select select-group getLabel " + selectClassName}
        aria-label="Default select example"
        name={name}
        id={name}
        value={value}
        onChange={handleChange}
        onInput={inputFocus}
        required
        datagroup={datagroup}
      >
        <option defaultValue=""></option>
        {options &&
          options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      <div className="invalid-tooltip">
        Veuillez remplir ce champs obligatoire
      </div>
    </div>
  );
};

export default Select;
